import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

export const Footer: React.FC = () => (
  <footer className={styles.footer}>
    <div className={styles.container}>
      {/* Brand & SJI Network */}
      <div className={styles.brandCol}>
        <h3 className={styles.brandTitle}>Tools by SJI</h3>
        <p className={styles.tagline}>
          Fast, free, and privacy-first web utilities for images and PDF documents.
          All file operations execute locally within your browser.
        </p>
        <div className={styles.privacyBadge}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-hidden="true">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          <span>100% In-Browser • Zero Server Uploads</span>
        </div>
      </div>

      {/* Popular Image Tools */}
      <div className={styles.column}>
        <h4 className={styles.colTitle}>Image Tools</h4>
        <ul className={styles.linkList}>
          <li><Link to="/image/compress">Compress Images</Link></li>
          <li><Link to="/image/resize">Resize Images</Link></li>
          <li><Link to="/image/crop">Crop Images</Link></li>
          <li><Link to="/image/png-to-jpg">PNG to JPG</Link></li>
          <li><Link to="/image/webp-converter">WebP Converter</Link></li>
          <li><Link to="/image/heic-converter">HEIC Converter</Link></li>
          <li><Link to="/image/image-to-pdf">Image to PDF</Link></li>
          <li><Link to="/image" className={styles.viewAll}>View all image tools →</Link></li>
        </ul>
      </div>

      {/* Popular PDF Tools */}
      <div className={styles.column}>
        <h4 className={styles.colTitle}>PDF Tools</h4>
        <ul className={styles.linkList}>
          <li><Link to="/pdf/merge">Merge PDF</Link></li>
          <li><Link to="/pdf/split">Split PDF</Link></li>
          <li><Link to="/pdf/rotate">Rotate PDF</Link></li>
          <li><Link to="/pdf/compress">Compress PDF</Link></li>
          <li><Link to="/pdf/remove-pages">Remove PDF Pages</Link></li>
          <li><Link to="/pdf/page-numbering">Add Page Numbers</Link></li>
          <li><Link to="/pdf/pdf-to-image">PDF to Images</Link></li>
          <li><Link to="/pdf" className={styles.viewAll}>View all PDF tools →</Link></li>
        </ul>
      </div>

      {/* SJI Ecosystem */}
      <div className={styles.column}>
        <h4 className={styles.colTitle}>SJI Network</h4>
        <ul className={styles.linkList}>
          <li>
            <a href="https://sji.one/" target="_blank" rel="noopener noreferrer">
              SJI Network (sji.one) ↗
            </a>
          </li>
          <li>
            <a href="https://calculators.sji.one/" target="_blank" rel="noopener noreferrer">
              Calculators by SJI ↗
            </a>
          </li>
          <li>
            <a href="https://time.sji.one/" target="_blank" rel="noopener noreferrer">
              Time Tools (time.sji.one) ↗
            </a>
          </li>
          <li>
            <a href="https://scratchpad.sji.one/" target="_blank" rel="noopener noreferrer">
              Scratchpad (scratchpad.sji.one) ↗
            </a>
          </li>
          <li>
            <a href="https://tempbox.sji.one/" target="_blank" rel="noopener noreferrer">
              Tempbox Mail (tempbox.sji.one) ↗
            </a>
          </li>
          <li>
            <a href="https://shorty.sji.one/" target="_blank" rel="noopener noreferrer">
              Shorty Links (shorty.sji.one) ↗
            </a>
          </li>
        </ul>
      </div>

      {/* Company & Resources */}
      <div className={styles.column}>
        <h4 className={styles.colTitle}>Company</h4>
        <ul className={styles.linkList}>
          <li><Link to="/about">About Tools</Link></li>
          <li><Link to="/blog">Blog &amp; Guides</Link></li>
          <li><Link to="/privacy">Privacy Policy</Link></li>
          <li><Link to="/terms">Terms of Service</Link></li>
        </ul>
      </div>
    </div>

    {/* Bottom Bar */}
    <div className={styles.bottomBar}>
      <div>
        &copy; {new Date().getFullYear()} <a href="https://sji.one/" target="_blank" rel="noopener noreferrer">SJI</a>. All rights reserved.
      </div>
      <div>
        Part of the <a href="https://sji.one/" target="_blank" rel="noopener noreferrer">SJI Network</a> &bull; Privacy-First Online Tools
      </div>
    </div>
  </footer>
);

export default Footer;
